// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31tDf","colBig":"styles_colBig__1-14N","colSmall":"styles_colSmall__1tznX","shopifyNameWrapper":"styles_shopifyNameWrapper__vYI8i"};